import React from 'react';
import {
  Worker,
  Viewer,
  SpecialZoomLevel,
  ProgressBar,
} from '@react-pdf-viewer/core';

import '@react-pdf-viewer/core/lib/styles/index.css';
import { useStore } from '../../context/appContext';

function PdfView({ pdf, setView }) {
  const { setError } = useStore();
  const renderError = (error) => {
    const pdfError = {};
    let description = '';
    switch (error.name) {
      case 'InvalidPDFException':
        description = 'El documento es invalido o esta corrupto';
        break;
      case 'MissingPDFException':
        description = 'Documento no encontrado';
        break;
      case 'UnexpectedResponseException':
        description = 'Servicio no disponible';
        break;
      default:
        description = 'No se puede cargar el documento';
        break;
    }
    pdfError.type = 'PDF Error';
    pdfError.description = description;
    setError(pdfError);

    return null;
  };

  // enable button after viewing contract
  const onPageChange = (e) => {
    if (e.currentPage === 9) {
      setView(false);
    };
  };

  return (
    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
      <Viewer
        defaultScale={SpecialZoomLevel.PageFit}
        fileUrl={pdf}
        onPageChange={onPageChange}
        renderError={renderError}
        renderLoader={(percentages) => (
          <div style={{ width: '240px' }}>
            <ProgressBar progress={Math.round(percentages)} />
          </div>
        )}
      />
    </Worker>
  );
}

export default PdfView;
